export enum Status {
    COMPLETED = 'completed',
    LOCKED = 'locked',
}

export enum EventType {
    DAILY_STREAK = 'daily_streak',
    COMPLETED_SESSION = 'completed_session',
}

export const LIMIT_FOR_PAGINATION = 12;
export const SIZE_PAGE_OPTIONS = [
    { value: 12, label: 12 },
    { value: 24, label: 24 },
    { value: 36, label: 36 },
];